import CategoryLabel from './CategoryLabel';

export default CategoryLabel;
